import ExportedImage from 'next-image-export-optimizer';
import Apligraf_RGB_OL from '../../../../../../../../../public/images/Apligraf_RGB_OL.webp';
import Apligraf_1_2019_Top_shadow_RGB from '../../../../../../../../../public/images/Apligraf_1_2019_Top_shadow_RGB.webp';

const ProductUsedForHealing = () => {
  return (
    <div className="mt-[76px] max-w-[1090px] mx-auto font-roboto-condensed">
      <div className="bg-[#007FA4] bg-opacity-40 px-8 py-5">
        <h4 className="text-[22px] lg:text-[min(2.2vw,30px)] font-roboto-condensed font-bold text-ogn-blue">
          A product used for healing Diabetic Foot Ulcers and Venous Leg Ulcers
        </h4>
      </div>
      <div className="bg-[#007FA4] bg-opacity-15 px-10 pb-4 grid grid-cols-1 lg:grid-cols-2 gap-x-9">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(120px,auto)_minmax(130px,1fr)]">
          <ExportedImage
            src={Apligraf_1_2019_Top_shadow_RGB}
            alt="Apligraf_1_2019_Top_shadow_RGB"
            width={266}
            height={265}
            className="order-1 lg:order-2 mx-auto w-full max-w-[266px] lg:mx-0 object-scale-down lg:ml-auto lg:my-auto"
          />
          <ExportedImage
            src={Apligraf_RGB_OL}
            alt="Apligraf_RGB_OL"
            width={152}
            height={62}
            className="order-2 lg:order-1 mt-6 h-[62px] w-full max-w-[152px] lg:mx-0 object-scale-down"
          />
        </div>

        <p className="order-3 lg:order-3 text-[18px] lg:text-[min(1.5vw,24px)] text-ogn-blue my-6 lg:mb-0 max-w-[490px]">
          Apligraf is a living cellular product that is FDA-approved to heal two
          specific types of wounds: Diabetic Foot Ulcers (DFUs) and Venous Leg
          Ulcers (VLUs). It is an advanced treatment created from cells found in
          healthy human skin and collagen derived from cows.
        </p>
      </div>
    </div>
  );
};

export { ProductUsedForHealing };
